import { motion } from "framer-motion";

// Scroll-reveal sobrio: fade + leggero spostamento verticale, una sola volta.
export const Reveal = ({ children, delay = 0, className, as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </Tag>
  );
};

// Eyebrow label di sezione
export const SectionLabel = ({ children }) => (
  <p className="text-xs font-semibold uppercase tracking-[0.22em] text-celeste-dark">
    {children}
  </p>
);
